// extracted by mini-css-extract-plugin
module.exports = {"DropDownContainer":"DropDownMenu_DropDownContainer__1XXiG","detail":"DropDownMenu_detail__1_7bX","holder":"DropDownMenu_holder__1OG5J"};